export default "__VITE_ASSET__DQ91HBQ6__"